import { Select, SelectProps } from 'antd';
import { useGetAllUsersQuery } from 'app/api';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { IOption } from 'types';
import { formatUserName } from 'utils/helpers';

interface IProps extends SelectProps<number> {}

const UserSelect: FC<IProps> = props => {
  const envId = useSelector(selectSelectedEnvId) as number;

  const { data, isFetching } = useGetAllUsersQuery({ envId }, { skip: !envId });

  const options: IOption[] | undefined = data?.map(user => ({
    value: user.id,
    label: formatUserName(user),
  }));

  return (
    <Select
      loading={isFetching}
      options={options}
      allowClear={true}
      dropdownMatchSelectWidth={false}
      {...props}
    />
  );
};

export default UserSelect;
